// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.N94X7wK1ukiJvGEzYh5P {
  display: block;
  position: relative;
  user-select: none;
  cursor: pointer;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  font-size: 0;
}
@media only screen and (max-width: 1259px) {
  .N94X7wK1ukiJvGEzYh5P.Y5ETPAF9LgNSv7bX_b_0 .IeGbHk4DjRN6RHAYDK6X:checked + .qNdMVPynHiP9SSt4L2Lg .Xy9GO79KWw4dq1Jzs_F5:first-child {
    display: flex;
  }
  .N94X7wK1ukiJvGEzYh5P.Y5ETPAF9LgNSv7bX_b_0 .qNdMVPynHiP9SSt4L2Lg {
    display: flex;
    padding: 4px 2px;
    border-radius: 20px;
  }
  .N94X7wK1ukiJvGEzYh5P.Y5ETPAF9LgNSv7bX_b_0 .Xy9GO79KWw4dq1Jzs_F5 {
    display: flex;
    height: 32px;
    border-radius: 16px;
    font-size: 15px;
  }
  .N94X7wK1ukiJvGEzYh5P.Y5ETPAF9LgNSv7bX_b_0 .Xy9GO79KWw4dq1Jzs_F5 svg {
    margin-right: 8px;
  }
}

.IeGbHk4DjRN6RHAYDK6X {
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
}
.IeGbHk4DjRN6RHAYDK6X:checked + .qNdMVPynHiP9SSt4L2Lg {
  background: #111315;
}
.IeGbHk4DjRN6RHAYDK6X:checked + .qNdMVPynHiP9SSt4L2Lg .Xy9GO79KWw4dq1Jzs_F5:first-child {
  background: none;
  box-shadow: none;
  color: #6F767E;
}
@media only screen and (max-width: 1259px) {
  .IeGbHk4DjRN6RHAYDK6X:checked + .qNdMVPynHiP9SSt4L2Lg .Xy9GO79KWw4dq1Jzs_F5:first-child {
    display: none;
  }
}
@media only screen and (max-width: 767px) {
  .IeGbHk4DjRN6RHAYDK6X:checked + .qNdMVPynHiP9SSt4L2Lg .Xy9GO79KWw4dq1Jzs_F5:first-child {
    display: flex;
  }
}
.IeGbHk4DjRN6RHAYDK6X:checked + .qNdMVPynHiP9SSt4L2Lg .Xy9GO79KWw4dq1Jzs_F5:first-child svg {
  fill: #6F767E;
}
.IeGbHk4DjRN6RHAYDK6X:checked + .qNdMVPynHiP9SSt4L2Lg .Xy9GO79KWw4dq1Jzs_F5:first-child:hover {
  color: #FCFCFC;
}
.IeGbHk4DjRN6RHAYDK6X:checked + .qNdMVPynHiP9SSt4L2Lg .Xy9GO79KWw4dq1Jzs_F5:first-child:hover svg {
  fill: #FCFCFC;
}
.IeGbHk4DjRN6RHAYDK6X:checked + .qNdMVPynHiP9SSt4L2Lg .Xy9GO79KWw4dq1Jzs_F5:nth-child(2) {
  box-shadow: 0px 4px 8px -4px rgba(0, 0, 0, 0.25), inset 0px -1px 1px rgba(0, 0, 0, 0.49), inset 0px 2px 1px rgba(255, 255, 255, 0.06);
  background: #272B30;
  color: #FCFCFC;
}
.IeGbHk4DjRN6RHAYDK6X:checked + .qNdMVPynHiP9SSt4L2Lg .Xy9GO79KWw4dq1Jzs_F5:nth-child(2) svg {
  fill: #FCFCFC;
}
@media only screen and (max-width: 1259px) {
  .IeGbHk4DjRN6RHAYDK6X:checked + .qNdMVPynHiP9SSt4L2Lg .Xy9GO79KWw4dq1Jzs_F5:nth-child(2) {
    display: flex;
  }
}

.qNdMVPynHiP9SSt4L2Lg {
  position: relative;
  display: flex;
  padding: 4px 2px;
  border-radius: 20px;
  background: #F4F4F4;
  transition: background 0.2s;
}
@media only screen and (max-width: 1259px) {
  .qNdMVPynHiP9SSt4L2Lg {
    display: block;
    padding: 2px;
    border-radius: 50%;
  }
}
@media only screen and (max-width: 767px) {
  .qNdMVPynHiP9SSt4L2Lg {
    display: flex;
    padding: 4px 2px;
    border-radius: 20px;
  }
}

.Xy9GO79KWw4dq1Jzs_F5 {
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 0 0 calc(50% - 4px);
  height: 32px;
  margin: 2px;
  border-radius: 16px;
  font-size: 15px;
  transition: background 0.2s, box-shadow 0.2s, color 0.2s;
}
@media only screen and (max-width: 1259px) {
  .Xy9GO79KWw4dq1Jzs_F5 {
    height: 40px;
    border-radius: 50%;
    font-size: 0;
  }
}
@media only screen and (max-width: 767px) {
  .Xy9GO79KWw4dq1Jzs_F5 {
    height: 32px;
    border-radius: 16px;
    font-size: 15px;
  }
}
.Xy9GO79KWw4dq1Jzs_F5 svg {
  margin-right: 8px;
  transition: fill 0.2s;
}
@media only screen and (max-width: 1259px) {
  .Xy9GO79KWw4dq1Jzs_F5 svg {
    margin-right: 0;
  }
}
@media only screen and (max-width: 767px) {
  .Xy9GO79KWw4dq1Jzs_F5 svg {
    margin-right: 8px;
  }
}
.Xy9GO79KWw4dq1Jzs_F5:first-child {
  background: #FCFCFC;
  box-shadow: 0px 4px 8px -4px rgba(0, 0, 0, 0.25), inset 0px -1px 1px rgba(0, 0, 0, 0.04), inset 0px 2px 0px rgba(255, 255, 255, 0.25);
}
.Xy9GO79KWw4dq1Jzs_F5:nth-child(2) {
  color: #6F767E;
}
@media only screen and (max-width: 1259px) {
  .Xy9GO79KWw4dq1Jzs_F5:nth-child(2) {
    display: none;
  }
}
@media only screen and (max-width: 767px) {
  .Xy9GO79KWw4dq1Jzs_F5:nth-child(2) {
    display: flex;
  }
}
.Xy9GO79KWw4dq1Jzs_F5:nth-child(2) svg {
  fill: #6F767E;
}
.Xy9GO79KWw4dq1Jzs_F5:hover {
  color: #1A1D1F;
}
.Xy9GO79KWw4dq1Jzs_F5:hover svg {
  fill: #1A1D1F;
}`, "",{"version":3,"sources":["webpack://./src/components/Theme/Theme.module.sass","webpack://./src/styles/helpers.sass"],"names":[],"mappings":"AAEA;EACI,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,6CAAA;EACA,YAAA;AADJ;ACGI;EDGgB;IACI,aAAA;EAHtB;EAIU;IACI,aAAA;IACA,gBAAA;IACA,mBAAA;EAFd;EAGU;IACI,aAAA;IACA,YAAA;IACA,mBAAA;IACA,eAAA;EADd;EAEc;IACI,iBAAA;EAAlB;AACF;;AACA;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;AAEJ;AADI;EACI,mBCeH;ADZL;AADY;EACI,gBAAA;EACA,gBAAA;EACA,cCMX;ADHL;AC/BI;EDyBQ;IAKQ,aAAA;EAKlB;AACF;AC9BI;EDmBQ;IAOQ,aAAA;EAQlB;AACF;AARgB;EACI,aAAA;AAUpB;AATgB;EACI,cCLf;ADgBL;AAVoB;EACI,aCPnB;ADmBL;AAXY;EACI,qIAAA;EACA,mBCLX;EDMW,cCXX;ADwBL;AAZgB;EACI,aCbf;AD2BL;AC1DI;EDuCQ;IAOQ,aAAA;EAgBlB;AACF;;AAdA;EACI,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBCtBC;EDuBD,2BAAA;AAiBJ;ACxEI;EDiDJ;IAQQ,cAAA;IACA,YAAA;IACA,kBAAA;EAmBN;AACF;ACzEI;ED2CJ;IAYQ,aAAA;IACA,gBAAA;IACA,mBAAA;EAsBN;AACF;;AArBA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;EACA,wDAAA;AAwBJ;AClGI;EDiEJ;IAWQ,YAAA;IACA,kBAAA;IACA,YAAA;EA0BN;AACF;ACnGI;ED2DJ;IAeQ,YAAA;IACA,mBAAA;IACA,eAAA;EA6BN;AACF;AA7BI;EACI,iBAAA;EACA,qBAAA;AA+BR;ACpHI;EDmFA;IAIQ,eAAA;EAiCV;AACF;ACnHI;ED6EA;IAMQ,iBAAA;EAoCV;AACF;AApCI;EACI,mBC5DH;ED6DG,qIAAA;AAsCR;AArCI;EACI,cC5DH;ADmGL;ACrII;ED6FA;IAGQ,aAAA;EAyCV;AACF;ACpII;EDuFA;IAKQ,aAAA;EA4CV;AACF;AA5CQ;EACI,aClEP;ADgHL;AA7CI;EACI,cCjEH;ADgHL;AA9CQ;EACI,aCnEP;ADmHL","sourcesContent":["@import ../../styles/helpers\n\n.theme\n    display: block\n    position: relative\n    user-select: none \n    cursor: pointer\n    -webkit-tap-highlight-color: rgba(0,0,0,0)\n    font-size: 0\n    &.wide\n        +d\n            .input:checked + .inner\n                .box\n                    &:first-child\n                        display: flex\n            .inner\n                display: flex   \n                padding: 4px 2px \n                border-radius: 20px\n            .box\n                display: flex\n                height: 32px\n                border-radius: 16px\n                font-size: 15px\n                svg\n                    margin-right: 8px\n\n.input\n    position: absolute\n    top: 0\n    left: 0\n    opacity: 0\n    &:checked + .inner \n        background: $n8\n        .box\n            &:first-child\n                background: none\n                box-shadow: none\n                color: $n4\n                +d\n                    display: none\n                +m\n                    display: flex\n                svg\n                    fill: $n4\n                &:hover\n                    color: $n1\n                    svg\n                        fill: $n1\n            &:nth-child(2)\n                box-shadow: 0px 4px 8px -4px rgba(0, 0, 0, 0.25), inset 0px -1px 1px rgba(0, 0, 0, 0.49), inset 0px 2px 1px rgba(255, 255, 255, 0.06)\n                background: $n6\n                color: $n1\n                svg\n                    fill: $n1\n                +d\n                    display: flex\n\n\n.inner\n    position: relative\n    display: flex   \n    padding: 4px 2px \n    border-radius: 20px\n    background: $n2\n    transition: background .2s\n    +d\n        display: block\n        padding: 2px\n        border-radius: 50%\n    +m\n        display: flex\n        padding: 4px 2px\n        border-radius: 20px\n\n.box\n    display: flex\n    justify-content: center\n    align-items: center\n    flex: 0 0 calc(50% - 4px)\n    height: 32px\n    margin: 2px\n    border-radius: 16px\n    font-size: 15px\n    transition: background .2s, box-shadow .2s, color .2s\n    +d\n        height: 40px\n        border-radius: 50%\n        font-size: 0\n    +m\n        height: 32px\n        border-radius: 16px\n        font-size: 15px\n    svg\n        margin-right: 8px\n        transition: fill .2s\n        +d\n            margin-right: 0\n        +m\n            margin-right: 8px\n    &:first-child\n        background: $n1\n        box-shadow: 0px 4px 8px -4px rgba(0, 0, 0, 0.25), inset 0px -1px 1px rgba(0, 0, 0, 0.04), inset 0px 2px 0px rgba(255, 255, 255, 0.25)\n    &:nth-child(2)\n        color: $n4\n        +d\n            display: none\n        +m\n            display: flex\n        svg\n            fill: $n4\n    &:hover\n        color: $n7\n        svg\n            fill: $n7\n\n\n    ","@use \"sass:math\"\n\n// media queries\n=w\n    @media only screen and (max-width: \"1419px\")\n        @content\n=x\n    @media only screen and (max-width: \"1339px\")\n        @content\n=d\n    @media only screen and (max-width: \"1259px\")\n        @content\n=t\n    @media only screen and (max-width: \"1023px\")\n        @content\n=m\n    @media only screen and (max-width: \"767px\")\n        @content\n=a\n    @media only screen and (max-width: \"639px\")\n        @content\n=s\n    @media only screen and (max-width: \"474px\")\n        @content\n\n// fonts\n=inter\n    font-family: 'Inter', sans-serif\n\n// colors\n$p1: #2A85FF\n$p2: #83BF6E\n$p3: #FF6A55\n$p4: #8E59FF\n$s1: #FFBC99\n$s2: #CABDFF\n$s3: #B1E5FC\n$s4: #B5E4CA\n$s5: #FFD88D\n\n$n: #FFFFFF\n$n1: #FCFCFC\n$n2: #F4F4F4\n$n3: #EFEFEF\n$n4: #6F767E\n$n5: #33383F\n$n6: #272B30\n$n7: #1A1D1F\n$n8: #111315\n\n$shades1: #9A9FA5\n$shades2: #6F767E\n$shades3: rgba(#6F767E, .4)\n$shades4: rgba(#111315, .5)\n\n// typography\n=title1-s\n    font-size: 20px\n    font-weight: 600\n    line-height: math.div( 32 , 20 )\n    letter-spacing: -.02em\n    +m\n        font-size: 18px\n\n=title1-m\n    font-size: 20px\n    font-weight: 500\n    line-height: math.div(32,20)\n    letter-spacing: -.02em\n    +m\n        font-size: 18px\n\n=title2\n    font-size: 18px\n    line-height: math.div(24,18)\n    letter-spacing: -0.02em\n\n=base1-s\n    font-size: 15px\n    font-weight: 600\n    line-height: math.div(24,15)\n\n=base1-b\n    font-size: 15px\n    font-weight: 700\n    line-height: math.div(24,15)\n\n=base2\n    font-size: 14px\n    font-weight: 600\n    line-height: math.div(24,14)\n\n=body1-m\n    font-size: 15px\n    font-weight: 500\n    line-height: math.div(24,15)\n    letter-spacing: -.015em\n\n=body1-s\n    font-size: 15px\n    font-weight: 600\n    line-height: math.div(24,15)\n    letter-spacing: -.015em\n\n=body2-s\n    font-size: 14px\n    font-weight: 600\n    line-height: math.div(24,14)\n\n=caption1\n    font-size: 13px\n    font-weight: 600\n    line-height: math.div(16,13)\n\n=caption1-m\n    font-size: 13px\n    font-weight: 500\n    line-height: math.div(16,13)\n\n=caption2\n    font-size: 12px\n    font-weight: 700\n    line-height: math.div(16,12)\n\n=caption2-m\n    font-size: 12px\n    font-weight: 500\n    line-height: 1\n\n=button1\n    font-size: 15px\n    font-weight: 700\n    line-height: math.div(24,15)\n\n=button2\n    font-size: 13px\n    font-weight: 700\n    line-height: math.div(24,13)\n    \n//triangle\n=arr($width, $height, $bg, $direction)\n    width: 0px\n    height: 0px\n    border-style: solid\n    @if $direction == t\n        border-width: 0 $width / 2 + px $height + px $width / 2 + px\n        border-color: transparent transparent $bg transparent\n    @if $direction == r\n        border-width: $height / 2 + px 0 $height / 2 + px $width + px\n        border-color: transparent transparent transparent $bg\n    @if $direction == b\n        border-width: $height + px $width / 2 + px 0 $width / 2 + px\n        border-color: $bg transparent transparent transparent\n    @if $direction == l\n        border-width: $height / 2 + px $width + px $height / 2 + px 0\n        border-color: transparent $bg transparent transparent\n    @if $direction == tl\n        border-width: $height + px $width + px 0 0\n        border-color: $bg transparent transparent transparent\n    @if $direction == tr\n        border-width: 0 $width + px $height + px 0\n        border-color: transparent $bg transparent transparent\n    @if $direction == br\n        border-width: 0 0 $height + px $width + px\n        border-color: transparent transparent $bg transparent\n    @if $direction == bl\n        border-width: $width + px 0 0 $height + px\n        border-color: transparent transparent transparent $bg\n// example\n// +arr(500,50, #000, l)\n// +arr(500,50, #000, bl)\n\n// placeholder\n=placeholder\n    &::placeholder\n        @content\n\n// media query width\n=r($width)\n    @media only screen and (max-width: $width+ \"px\")\n        @content\n\n=rmin($width)\n    @media only screen and (min-width: $width+ \"px\")\n        @content\n\n// theme\n=dark\n    @at-root :global(.dark-mode) &\n        @content\n\n=dark-body\n    @at-root .dark-mode\n        @content\n\n=dark-common\n    @at-root .dark-mode &\n        @content"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"theme": `N94X7wK1ukiJvGEzYh5P`,
	"wide": `Y5ETPAF9LgNSv7bX_b_0`,
	"input": `IeGbHk4DjRN6RHAYDK6X`,
	"inner": `qNdMVPynHiP9SSt4L2Lg`,
	"box": `Xy9GO79KWw4dq1Jzs_F5`
};
export default ___CSS_LOADER_EXPORT___;
